import * as React from "react";

function SvgYoutube(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 81 58"
      fill="#fff"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <use xlinkHref="#youtube_svg__a" x={0.5} y={0.5} />
      <symbol id="youtube_svg__a" overflow="visible">
        <g stroke="none" fillRule="nonzero">
          <path
            d="M78.235 8.773a10.056 10.056 0 00-7.08-7.08C64.946 0 39.96 0 39.96 0S14.973.051 8.765 1.744a10.054 10.054 0 00-7.08 7.08c-1.878 11.031-2.606 27.839.051 38.429a10.056 10.056 0 007.08 7.08c6.208 1.693 31.195 1.693 31.195 1.693s24.986 0 31.195-1.693a10.056 10.056 0 007.08-7.08c1.98-11.046 2.591-27.844-.051-38.48z"
            fill="red"
          />
          <path d="M32.007 40.02l20.728-12.006-20.728-12.006z" />
        </g>
      </symbol>
    </svg>
  );
}

export default React.forwardRef(SvgYoutube);
